<script setup lang="ts">
import { calculateNavigationPercent } from '@/helpers/navigationPercent';
import { usePropertyValuationStore } from '@/stores/propertyValuation';
import { storeToRefs } from 'pinia';
import { onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { formStep } = defineProps<{
  formStep: number;
}>();

const { t } = useI18n();
const propertyValuationStore = usePropertyValuationStore();
const { totalSteps } = storeToRefs(propertyValuationStore);
const navigationPercentage = ref(calculateNavigationPercent(formStep, totalSteps.value));

watch(
  () => formStep,
  () => {
    requestAnimationFrame(() => {
      navigationPercentage.value = calculateNavigationPercent(formStep + 1, totalSteps.value);
    });
  },
);

onMounted(() => {
  requestAnimationFrame(() => {
    navigationPercentage.value = calculateNavigationPercent(formStep + 1, totalSteps.value);
  });
});
</script>

<template>
  <div :class="$style.wrapper">
    <div :class="$style.label">
      <span>{{ t('propertyValuation.label') }} </span>
      <span>{{ navigationPercentage }}%</span>
    </div>
    <div>
      <div :class="$style.progress">
        <span :style="{ width: `${navigationPercentage}%` }" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.wrapper {
  min-width: 195px;
}

.backButton {
  padding: $space-25 $space-50 !important;
  margin-right: $space-50;
}

.progress {
  width: 100%;
  height: 6px;
  margin-top: 10px;
  vertical-align: middle;
  background: $color-grey-50;
  border-radius: $border-radius;

  span {
    display: block;
    height: 6px;
    background: $color-blue-30;
    border-radius: $border-radius;
    transition: width 2s cubic-bezier(0.05, 0.7, 0.1, 1);
  }
}

.label {
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: flex-start;
  justify-content: space-between;
}

.percentage {
  width: 32px;
  color: #595959;
}
</style>
